import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';

/* Mismos colores que los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-green-700 text-white', 'bg-blue-700 text-white', 'bg-coral text-white', 'bg-purple-700 text-white', 'bg-green-600 text-white', 'bg-teal-600 text-white'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-cielo text-navy" data-id="element-148" data-mp="12rrnrv2efdp">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-149" data-mp="3t7lt7jt5jggu">
        <p className="inline-block rounded-md bg-navy px-2 py-0.5 font-sub text-sm font-semibold leading-tight text-sol" data-id="element-150" data-mp="auxdejuq40kg">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-display text-[1.45rem] font-extrabold uppercase leading-[1.1] tracking-tight text-navy sm:text-4xl" data-id="element-151" data-mp="ks232tns2e60">
          <span className="bg-navy px-1.5 text-sol" data-id="element-152" data-mp="36am0zdl20hzq">6 tomos en un solo sistema,</span>{' '}
          creados para aprender inglés de viaje desde cero.
        </h2>
        <p className="mt-1.5 font-sub text-xs font-bold uppercase leading-tight text-coral sm:text-sm" data-id="element-153" data-mp="3ba8nkdmrval7">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-navy/80" data-id="element-154" data-mp="3kadihoas4gih">
          No es simplemente otro curso lleno de reglas gramaticales. Es una{' '}
          <strong className="font-bold text-navy" data-id="element-155" data-mp="3p982gtkhgb46">
            ruta de aprendizaje práctica
          </strong>{' '}
          que organiza el inglés que necesitás para desenvolverte durante un
          viaje, desde las primeras palabras hasta las conversaciones reales en
          aeropuertos, hoteles, restaurantes y situaciones de emergencia.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-156" data-mp="bvd39uwn12c6">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-navy bg-white text-left" data-id="element-157" data-mp="gt52l9zm3qqe" data-mpi={i}>
              <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-158" data-mp="27z1aolpu7wxl">
                <span className="font-sub text-[10px] font-bold uppercase tracking-wider" data-id="element-159" data-mp="2hvw6uxyn1l8p">
                  Tomo
                </span>
                <span className="font-display text-3xl font-black leading-none" data-id="element-160" data-mp="2vm9j3cikbm3u">
                  {i + 1}
                </span>
              </span>
              <div className="p-2.5" data-id="element-161" data-mp="2ro234jvxaotp">
                <h3 className="font-sub text-sm font-bold leading-tight text-navy" data-id="element-162" data-mp="35lqi5b3b71qu">
                  <span className="sr-only" data-id="element-163" data-mp="30lvvxkuhb0c4">Tomo {i + 1} — </span>
                  {tomo.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-navy/80 sm:text-sm" data-id="element-164" data-mp="1b8imjh7iem45">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-165" data-mp="3hwrbux4do9xl">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}